(() => {
  const SELECTOR = '[data-bcj-announcement-bar]';
  const HIDDEN_CLASS = 'is-hidden';
  const ROOT_HIDDEN_CLASS = 'bcj-announcement-hidden';
  const MIN_SCROLL_DELTA = 8;
  const TOP_REVEAL_OFFSET = 8;

  const initBar = (bar) => {
    if (!bar || bar.dataset.bcjAnnouncementInited === 'true') return;
    bar.dataset.bcjAnnouncementInited = 'true';

    const hideOnScroll = bar.dataset.hideOnScroll !== 'false';
    let lastScrollY = window.scrollY || 0;
    let touchStartY = null;
    let ticking = false;
    let resizeObserver = null;
    let isActive = true;

    const syncHeight = () => {
      const height = Math.ceil(bar.getBoundingClientRect().height || 0);
      document.documentElement.style.setProperty('--bcj-announcement-height', `${height}px`);
    };

    const setHidden = (shouldHide) => {
      if (shouldHide && bar.contains(document.activeElement)) return;
      bar.classList.toggle(HIDDEN_CLASS, Boolean(shouldHide));
      bar.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      bar.inert = Boolean(shouldHide);
      document.documentElement.classList.toggle(ROOT_HIDDEN_CLASS, Boolean(shouldHide));
    };

    const updateOnScroll = () => {
      ticking = false;
      if (!hideOnScroll) return;

      const currentY = Math.max(0, window.scrollY || 0);
      const delta = currentY - lastScrollY;

      if (currentY <= TOP_REVEAL_OFFSET) {
        setHidden(false);
      } else if (delta > MIN_SCROLL_DELTA) {
        setHidden(true);
      } else if (delta < -MIN_SCROLL_DELTA) {
        setHidden(false);
      }

      lastScrollY = currentY;
    };

    const requestScrollUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateOnScroll);
    };

    const handleTouchStart = (event) => {
      touchStartY = event.touches && event.touches.length ? event.touches[0].clientY : null;
    };
    const handleTouchMove = (event) => {
      if (touchStartY === null || !event.touches || !event.touches.length) return;
      const touchY = event.touches[0].clientY;
      const swipeDelta = touchStartY - touchY;
      if (Math.abs(swipeDelta) < 18) return;
      setHidden(swipeDelta > 0);
    };
    const handleTouchEnd = () => { touchStartY = null; };

    syncHeight();
    window.addEventListener('resize', syncHeight);
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(syncHeight);
      resizeObserver.observe(bar);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => { if (isActive) syncHeight(); });
    }

    if (hideOnScroll) {
      window.addEventListener('scroll', requestScrollUpdate, { passive: true });
      window.addEventListener('touchstart', handleTouchStart, { passive: true });
      window.addEventListener('touchmove', handleTouchMove, { passive: true });
      window.addEventListener('touchend', handleTouchEnd, { passive: true });
    }

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target || !event.target.contains(bar)) return;
      isActive = false;
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('resize', syncHeight);
      window.removeEventListener('scroll', requestScrollUpdate);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
      document.documentElement.style.removeProperty('--bcj-announcement-height');
      document.documentElement.classList.remove(ROOT_HIDDEN_CLASS);
    });
  };

  const initAll = () => {
    document.querySelectorAll(SELECTOR).forEach(initBar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
